<template>
  <b-container class="highlight-container">

    <router-link to="/"><i class="fas fa-times btn--close"></i></router-link>

    <b-row>
      <b-col md="12" class="text-center px-0">
        <img v-scroll-reveal src="/img/icons/community-title.svg" alt="New Seaton" fluid center class="community-title"
          style="max-width: 450px;">
        <h1 v-scroll-reveal>Built From the Ground Up</h1>
        <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/communityvision-highlight-banner.png" fluid center alt="New Seaton Community Vision"/>
        </div>
      </b-col>
    </b-row>

    <b-row class="background--white">
      <b-col md="10" offset-md="1" class="text-center">
        <h3 class="text--red text--extrabold mb-25"><a data-fancybox="video" href="https://player.vimeo.com/video/359371131?title=0&byline=0&portrait=0&transparent=0">WATCH
            VIDEO</a></h3>
        <p v-scroll-reveal>
          At New Seaton, you can get that "new home feeling" throughout the entire community. <br class="d-none d-xl-block">That's
          because New Seaton
          is one of this generation's only communities that is <br class="d-none d-xl-block">truly built from the
          ground up. Working closely with
          multiple levels of government, every detail <br class="d-none d-xl-block">of this community has been
          carefully planned to make your life
          easier. Thoughtfully placed schools <br class="d-none d-xl-block">and parks. The perfect balance of
          residential and commercial. Convenient
          transit and commuting.
        </p>
        <highlight-footer slot="register" />
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
  import highlightFooter from '@/components/HighlightFooter';
  export default {
    components: {
      highlightFooter
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation()
      this.ConfirmInterest()
    },
    methods:{
      ConfirmInterest(){
        if(this.$route.query.email){
            var query = this.$route.query;
            var getEmail = query.email.toString();
          $.ajax({
              method: 'POST',
              url: 'https://newseaton.com/addSubscriber.php',
              crossDomain: true,
              data: {
                    email: getEmail,
                    firstname: query.firstname,
                    lastname: query.lastname,
                    phone_number: query.phone,
                    postal_code: query.postalcode,
                    type_of_buyer: query.type,
                    how_did_you_hear_about_us: query.source,
                    other: query.other
              }
          })
          .done(function(msg){
            console.log(msg);         
          })
        }
      }
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }
</script>

<style scoped>

</style>